import { Typography, Box, Chip } from "@mui/material";

const Header = ({ title, subtitle, action, hideVersion = false }) => {
  const appVersion = (process.env.REACT_APP_VERSION || "").trim();
  return (
    <Box mb={2} mt={1} display="flex" alignItems="center" justifyContent="space-between">
      <Box>
        <Typography
          variant="h3"
          color="#212529"
          fontWeight={700}
          fontFamily="Montserrat, Arial, sans-serif"
          sx={{ m: 0, letterSpacing: 0.2 }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="h6" color="#868e96" fontWeight={400} fontFamily="Montserrat, Arial, sans-serif" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        {appVersion && !hideVersion && (
          <Chip
            size="small"
            label={`v${appVersion.replace(/^v/i, "")}`}
            sx={{ bgcolor: '#F1F3F5', color: '#495057', fontFamily: 'Montserrat, Arial, sans-serif' }}
          />
        )}
        {action && <Box>{action}</Box>}
      </Box>
    </Box>
  );
};

export default Header;
